import {
  computed, reactive, ref, ssrRef, unref,
} from '@nuxtjs/composition-api';
import { UA } from 'nuxt-user-agent/lib/plugin.template';

import { IBloczek } from '~/components/bloczki/types/IBloczek';
import TClusterRef from '~/components/map/types/clusterRef';
import IMapFitBoundsPadding from '~/components/map/types/IMapFitBoundsPadding';
import IMapSzukajServiceConfig from '~/components/map/types/IMapSzukajServiceConfig';
import TMapRef from '~/components/map/types/mapRef';
import IGoogleMapState from '~/components/map/types/mapState';
import { BloczekMarker } from '~/components/map/types/marker/BloczekMarker';
import IMarkersInnerState from '~/components/map/types/markersInnerState';

import buildConfig from '../config/buildConfig';
import getActiveMarker from '../marker/getActiveMarker';
import getInactiveMarkers from '../marker/getInactiveMarkers';

interface IBuildServiceConfigParam {
  cluster: TClusterRef;
  mapRef: TMapRef;
  $ua: UA;
}

const mapFitBoundsPadding = ($ua: UA): IMapFitBoundsPadding => ($ua.isFromPc()
  ? {
    bottom: 81,
    top: 81 + 50,
    left: 63,
    right: 63 + 24 + 16,
  }
  : {
    bottom: 97 + 42,
    top: 54 + 50 + 50 + 97,
    left: 79,
    right: 79,
  });

const buildServiceConfig = (params: IBuildServiceConfigParam): IMapSzukajServiceConfig => {
  const { mapRef, $ua, cluster } = params;
  const markersInnerState = reactive<IMarkersInnerState<BloczekMarker>>({
    markers: ssrRef(undefined),
    activeMarker: ref(unref(undefined)),
  });
  const mapState = reactive<IGoogleMapState<BloczekMarker, IBloczek>>({
    isMapToBeRendered: ref(false),
    activeMarkerExtended: ref(undefined),
    activeMarker: computed(() => getActiveMarker(markersInnerState)),
    inactiveMarkers: computed(() => getInactiveMarkers(markersInnerState)),
    markers: computed(() => markersInnerState.markers),
  });
  const result: IMapSzukajServiceConfig = {
    mapState,
    markersInnerState,
    config: buildConfig(),
    mapRef,
    cluster,
    mapFitBoundsPadding: mapFitBoundsPadding($ua),
  };

  return result;
};
export default buildServiceConfig;
